import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Translation, TranslocoLoader } from '@jsverse/transloco';
import { firstValueFrom } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class TranslocoHttpLoader implements TranslocoLoader {
    private http = inject(HttpClient);

    public getTranslation(lang: string): Promise<Translation> {
        return firstValueFrom(this.http.get<Translation>(`assets/i18n/${lang}.json`));
    }
}
